import React from 'react';
import '../styles/quiz.css';
import './discover-intro.css';

export const introDefaults = {
  eyebrow: 'Discover your reading level',
  heading: 'A new reading discovery',
  description: 'Read the passage, answer the questions and find your reading level.',
  resumeHeading: 'Continue your reading discovery',
  resumeDescription: 'Return to your reading discovery.',
  startLabel: 'Start quiz', resumeLabel: 'Continue quiz',
  image: '/branding/deenlit-background.png', imageAlt: 'An illustrated library overlooking a lake', imageCaption: '',
};
export default function DiscoverIntro({ quiz, answered = 0, busy = false, onStart, preview = false, resume: forcedResume }) {
  const content = { ...introDefaults, ...quiz.introduction };
  const passages = quiz.passages?.length || 0;
  const total = (quiz.passages || []).reduce((sum, p) => sum + (p.questions?.length || 0), 0);
  const resume = forcedResume ?? answered > 0;
  return <section className={`discover-intro ${content.image ? 'has-art' : ''}`} aria-label="Your reading discovery">
    <div className="discover-intro-copy">
      <span className="discover-intro-eyebrow">{content.eyebrow}</span>
      <h2>{resume ? content.resumeHeading : content.heading}</h2>
      <p>{resume ? content.resumeDescription : content.description}</p>
      <dl className="discover-intro-facts"><div><dt>{passages === 1 ? 'passage' : 'passages'}</dt><dd>{passages}</dd></div><div><dt>{total === 1 ? 'question' : 'questions'}</dt><dd>{total}</dd></div></dl>
      {resume && <div className="discover-intro-progress"><span>{answered} of {total} questions answered</span><progress aria-label="Saved answers" max={Math.max(1, total)} value={answered} /></div>}
      <button type="button" className="quiz-next" aria-label="Start or resume Discover Quiz" disabled={busy || preview} onClick={onStart}>{busy ? 'Opening quiz...' : resume ? content.resumeLabel : content.startLabel}<span aria-hidden="true">&#8594;</span></button>
    </div>
    {content.image && <figure className="discover-intro-art"><img src={content.image} alt={content.imageAlt || ''} />{content.imageCaption && <figcaption>{content.imageCaption}</figcaption>}</figure>}
  </section>;
}
